module.exports = __webpack_public_path__ + "img/red_diode.db793870.png";